import request from '../request.js'

//总概算 --- 张卫华
const getTotalEstimate = function (data) {
    return request({
        url: 'busCostBudget/getTotalEstimate',
        method: 'post',
        data
    })
}

// 获取六算分析信息 --- 张卫华
const sixCalculationAnalysis = function (data) {
    return request({
        url: 'busCostDetail/sixCalculationAnalysis',
        method: 'post',
        data
    })
}

// 获取六算分析信息 --- 郑勇
const getProjectCostAnalysis = function (data) {
    return request({
        url: 'analysisSheet/getProjectCostAnalysis',
        method: 'post',
        data
    })
}

// 获取六算分析信息
const getSheetAnalysis = function (data) {
    return request({
        url: 'analysisSheet/getSheetAnalysis',
        method: 'post',
        data
    })
}

export {
    getTotalEstimate,
    getSheetAnalysis,
    getProjectCostAnalysis,
    sixCalculationAnalysis,
}
